import {createAction} from '@reduxjs/toolkit'
import {PolicyUpdateField, SSLInspectionStatus} from 'interfaces'

export const updatePolicyUpdateField = createAction<PolicyUpdateField>(
  'updatePolicyUpdateField',
)
export const resetPolicyUpdateField = createAction('resetPolicyUpdateField')
export const formSubmitted = createAction<boolean>('formSubmitted')
export const savePressed = createAction<boolean>('savePressed')

export const updatePolicyName = createAction<string>('updatePolicyName')

// Set SSL Inspection state in data
export const setSSLInspectionData = createAction<SSLInspectionStatus>(
  'setSSLInspectionData',
)
// Set SSL Inspection state in snapshot
export const setSSLInspectionSnapshot = createAction<SSLInspectionStatus>(
  'setSSLInspectionSnapshot',
)
// Set SSL Inspection state in base policy
export const setSSLInspectionBasePolicy = createAction<SSLInspectionStatus>(
  'setSSLInspectionBasePolicy',
)
